// src/models/enums/MatchGenderEnum.ts

export enum MatchGenderEnum {
  MALE = "MALE",
  FEMALE = "FEMALE",
  MIXED = "MIXED"
}

// Turkish display labels for match gender
export const MatchGenderLabels: Record<MatchGenderEnum, string> = {
  [MatchGenderEnum.MALE]: "Erkek",
  [MatchGenderEnum.FEMALE]: "Kadın",
  [MatchGenderEnum.MIXED]: "Karışık"
};